module.exports = __webpack_public_path__ + "static/media/arrow.81e94ad1.svg";